import React, { Fragment } from 'react';
import { Redirect } from 'react-router-dom';

export default function NotFoundRedirect({ error, url, errors }) {

    let availableErrors = [404];

    if (errors && Array.isArray(errors)) {
        availableErrors = [...availableErrors, ...errors];
    }

    if (availableErrors.includes(error?.response?.status) || error) {
        return <Redirect to={url || `/404`} />;
    }

    return <Fragment></Fragment>;
}
